import styled from 'styled-components';

export default styled.div`
  display: flex;

  > .filter {
    flex: 0 0 40%;

    > h2 {
      flex: 0 0 auto;

      color: ${props => props.theme.palette.primary.main};
      font-size: 2.4rem;
      font-weight: 400;
    }

    > .select {
      padding: 2rem 0;
    }

    > .slider {
      padding-top: 5rem;

      display: flex;
      align-items: center;

      > p {
        flex: 0 0 7rem;
      }

      > .slider-input {
        flex: 1 1 auto;

        display: flex;
        align-items: center;

        > span {
          flex: 0 0 auto;
        }

        > div {
          flex: 1 1 auto;
          padding: 0 2rem;
        }
      }
    }
  }

  > .device {
    flex: 1 1 auto;

    padding-left: 5rem;

    > .container {
      position: relative;

      > .device-img {
        position: absolute;

        top: 0;
        left: 0;
      }

      > .battery-icon {
        position: absolute;

        .battery-svg {
          width: 100%;
          height: 100%;

          > path {
            transition: clip-path 1s;
          }
        }
      }

      > .endurance-rating {
        position: absolute;

        top: 50%;
        left: 50%;

        transform: translate(-50%, -50%);

        font-weight: bolder;
        font-size: 2rem;
      }
    }
  }
`;
